import config from "../../../../config";
import { ResponseDto } from '../../../../dtos/common/responseDto';
import { deleteData, getData, patchData, postData } from '../../../../utils/axios/serverHelper';
import { formatDate } from '../../../../utils/string/stringUtil';
import axios from 'axios';

import { PUR1020_R01PurchaseDto, PUR1020_R01SuppliedDto, PUR1020_R01Dto, PUR1020_R01HeaderDto } from './Dto_PUR1020_R01';
import { PUR1020_R01Filter } from "./Store_PUR1020_R01";

const baseUrl = `${config.apiUrl}/PUR1020_R01`;

const getParams = (filter: Partial<PUR1020_R01Filter>, listLength?: number) => {
	return {
		compCd: filter.compCd || undefined,
		customCd: filter.customCd || undefined,
		itemCd: filter.itemCd || undefined,
		itemGroup: filter.itemGroup || undefined,
		brandCd: filter.brandCd || undefined,
		startDate: filter.dateRange?.from ? formatDate(filter.dateRange.from) : undefined,
		endDate: filter.dateRange?.to ? formatDate(filter.dateRange.to) : undefined,
		logicCenter: filter.logicCenter || undefined,
		listLength: listLength || 0
	}
}

export const getPUR1020_R01List = async (option: string, params: Partial<PUR1020_R01Filter>, listLength: number = 0) => {

	const url = `${baseUrl}/${option}`;

    return await getData<ResponseDto<PUR1020_R01HeaderDto[]>>(url, { params: getParams(params, listLength) });
}

export const getPUR1020_R01AllCount = async (params: Partial<PUR1020_R01Filter>) => {
    const url = `${baseUrl}/allCount`;

    return await getData<ResponseDto<number>>(url, {
        params: getParams(params, 0)
    });
}

export const getPUR1020_R01Purchase = async (condition: string[]) => {
	const url = `${baseUrl}/detail/purchase`;

    return await getData<ResponseDto<PUR1020_R01PurchaseDto[]>>(url, {
        params: {
            condition: condition
        }
    });
}

export const getPUR1020_R01Supplied = async (condition: string[]) => {
	const url = `${baseUrl}/detail/supplied`;

    return await getData<ResponseDto<PUR1020_R01SuppliedDto[]>>(url, {
        params: {
            condition: condition
        }
    });
}



export const downloadExcel_PUR1020_R01 = async (condition: string[]) => {
	const url = `${baseUrl}/excel`;
    return await getData<ResponseDto<string>>(url, {
        params: {
            condition: condition
        }
    });
};
